module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0, false, false), _vm._v(" "), _c('section', [_c('div', {
    staticClass: "container"
  }, [_vm._m(1, false, false), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('center', [_c('form', {
    staticClass: "navbar-form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.keyword),
      expression: "keyword"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "請輸入聯盟聯盟名稱"
    },
    domProps: {
      "value": (_vm.keyword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.keyword = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.SearchingStore()
      }
    }
  }, [_vm._v("查詢")])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.alliances), function(row, index) {
    return _c('div', {
      staticClass: "col-md-3 col-sm-4 col-xs-6"
    }, [_c('div', {
      staticClass: "store_list"
    }, [_c('div', {
      staticClass: "store_box"
    }, [_c('router-link', {
      attrs: {
        "to": '/alliance/' + row.id
      }
    }, [_c('figure', {
      staticClass: "pic justify"
    }, [_c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": 'https://files.i80.com.tw/images/alliance/' + row.cover_photo
      }
    })]), _vm._v(" "), _c('h5', {
      staticClass: "title"
    }, [_vm._v(_vm._s(row.name))]), _vm._v(" "), _c('p', {
      staticClass: "txt"
    }, [_vm._v(_vm._s(row.description))])])], 1)])])
  })), _vm._v(" "), _vm._m(2, false, false)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "container"
  }, [_c('figure', [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/images/index/i80banner.png"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', {
    staticClass: "breadcrumb hidden-xs"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_vm._v("首頁")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/alliance"
    }
  }, [_vm._v("聯盟中心")])]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("中心介紹")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    attrs: {
      "aria-label": "..."
    }
  }, [_c('ul', {
    staticClass: "pagination"
  }, [_c('li', {
    staticClass: "disabled"
  }, [_c('a', {
    attrs: {
      "href": "#",
      "aria-label": "Previous"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("«")])])]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("1 "), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("(current)")])])]), _vm._v(" "), _c('li', {
    staticClass: "disabled"
  }, [_c('a', {
    attrs: {
      "href": "#",
      "aria-label": "Next"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("»")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5c734712"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Alliance.vue
// module id = 303
// module chunks = 1